import { ref, get } from "firebase/database";
import { database } from "../../Utils/firebase";

const CheckIsUserDeleted = async (userId) => {
    if (!userId) return null;

    try {
        const userRef = ref(database, `invoiceGenerator/deletedUsers/${userId}`);
        const snapshot = await get(userRef);
        const userData = snapshot.val();

    
        if (userData) {
            return true;
        }

        return false;
    } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
    }
};

export default CheckIsUserDeleted;